import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { gapClass } from './styles';
import support from './support';
var flexGapSupport = support();
var DefaultProps = {
  row: 8,
  column: 8
};

var Gap =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Gap, _PureComponent);

  var _super = _createSuper2(Gap);

  function Gap() {
    _classCallCheck(this, Gap);

    return _super.apply(this, arguments);
  }

  _createClass(Gap, [{
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          row = _this$props.row,
          column = _this$props.column,
          style = _this$props.style;
      var extendStyle = flexGapSupport ? {
        rowGap: row,
        columnGap: column
      } : {
        marginBottom: -Number(row)
      };
      return Object.assign({}, style, extendStyle);
    }
  }, {
    key: "getItemStyle",
    value: function getItemStyle(index) {
      var _this$props2 = this.props,
          row = _this$props2.row,
          column = _this$props2.column,
          itemStyle = _this$props2.itemStyle,
          children = _this$props2.children;
      if (flexGapSupport) return itemStyle;
      var isLast = React.Children.count(children) - 1 === index;
      return Object.assign({}, itemStyle, {
        marginBottom: row
      }, !isLast && {
        marginRight: column
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var children = this.props.children;
      var className = classnames(gapClass('_'), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: this.getStyle()
        }, React.Children.map(children, function (child, index) {
          return child &&
          /*#__PURE__*/
          React.createElement("div", {
            className: gapClass('item'),
            style: _this.getItemStyle(index)
          }, child);
        }))
      );
    }
  }]);

  return Gap;
}(PureComponent);

Gap.defaultProps = DefaultProps;
export default Gap;